<script>
export default {
  data() {
    return {
      legends: [
        { color: 'yellow', content: 'component.documentValidation.validationResultLegend.legend.sender' },
        { color: 'azure', content: 'component.documentValidation.validationResultLegend.legend.postage' },
        { color: 'green', content: 'component.documentValidation.validationResultLegend.legend.recipient' },
        { color: 'red', content: 'component.documentValidation.validationResultLegend.legend.free.spaces' }
      ]
    }
  }
}
</script>
<template>
  <v-card flat class="pa-0">
    <v-card-text class="pa-0">
      <v-row>
        <v-col>
          {{ $t('component.documentValidation.validationResultLegend.legend.header') }}
        </v-col>
      </v-row>
      <v-row
        v-for="(legend, index) in legends"
        :key="index"
        class="legend pl-4">
        <v-col cols="1">
          <div class="square" :class="legend.color"></div>
        </v-col>
        <v-col>
          <div>
            <h5>{{ $t(legend.content) }}</h5>
          </div>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>
<style lang="scss" scoped>
.square {
  width: 20px;
  height: 20px;
}
.legend {
  .green {
    border: 1px dotted #006400 !important;
    background-color: rgba(0, 255, 0, 0.294) !important;
  }
  .red {
    border: 1px dotted #640000 !important;
    background-color: rgba(255, 0, 0, 0.294) !important;
  }
  .yellow {
    border: 1px dotted #646400 !important;
    background-color: rgba(255, 255, 0, 0.294) !important;
  }
  .azure {
    border: 1px dotted #000064 !important;
    background-color: rgba(0, 0, 255, 0.1) !important;
  }
}
</style>
